import React from 'react';

export interface EmailTemplate {
  id: string;
  name: string;
  description: string;
  subject: string;
  htmlContent: string;
  thumbnail: string;
}

export const emailTemplates: EmailTemplate[] = [
  {
    id: 'welcome',
    name: 'Welcome Email',
    description: 'A friendly welcome email for new customers',
    subject: 'Welcome to {{businessName}}!',
    thumbnail: '🎉',
    htmlContent: `
<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Welcome to Our Company</title>
  <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap" rel="stylesheet">
  <style>
    body {
      font-family: 'Poppins', sans-serif;
      line-height: 1.6;
      color: #333;
      max-width: 600px;
      margin: 0 auto;
      padding: 20px;
    }
    .header {
      background-color: #4F46E5;
      color: white;
      padding: 20px;
      text-align: center;
      border-radius: 5px 5px 0 0;
    }
    .content {
      padding: 20px;
      background-color: #f9f9f9;
      border: 1px solid #eee;
    }
    .footer {
      text-align: center;
      padding: 10px;
      font-size: 12px;
      color: #666;
    }
    .button {
      display: inline-block;
      padding: 10px 20px;
      background-color: #4F46E5;
      color: white;
      text-decoration: none;
      border-radius: 5px;
      margin: 15px 0;
      font-weight: 500;
    }
  </style>
</head>
<body>
  <div class="header">
    <h1 style="color: white; font-weight: 600;">Welcome to {{businessName}}!</h1>
  </div>
  <div class="content">
    <p>Dear {{firstName}},</p>
    <p>We're thrilled to welcome you to {{businessName}}! Thank you for joining us.</p>
    <p>Your account has been successfully created and you can now start exploring our platform.</p>
    <p><a href="#" class="button" style="color: white;">Get Started</a></p>
    <p>If you have any questions, feel free to reply to this email or contact our support team.</p>
    <p>Best regards,<br>The {{businessName}} Team</p>
  </div>
  <div class="footer">
    <p>© {{year}} {{businessName}}. All rights reserved.</p>
    <p><a href="#">Unsubscribe</a> | <a href="#">View in browser</a></p>
  </div>
</body>
</html>
`
  },
  {
    id: 'promotion',
    name: 'Special Offer',
    description: 'Announce a special discount or promotion',
    subject: 'Special Offer: [[offer]] - Limited Time Only!',
    thumbnail: '🏷️',
    htmlContent: `
<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Special Offer</title>
  <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap" rel="stylesheet">
  <style>
    body {
      font-family: 'Poppins', sans-serif;
      line-height: 1.6;
      color: #333;
      max-width: 600px;
      margin: 0 auto;
      padding: 20px;
    }
    .header {
      background-color: #FF6B6B;
      color: white;
      padding: 20px;
      text-align: center;
      border-radius: 5px 5px 0 0;
    }
    .content {
      padding: 20px;
      background-color: #f9f9f9;
      border: 1px solid #eee;
    }
    .offer {
      background-color: #FFE66D;
      padding: 15px;
      text-align: center;
      font-size: 24px;
      font-weight: bold;
      margin: 20px 0;
      color: #333;
      border-radius: 5px;
    }
    .footer {
      text-align: center;
      padding: 10px;
      font-size: 12px;
      color: #666;
    }
    .button {
      display: inline-block;
      padding: 10px 20px;
      background-color: #FF6B6B;
      color: white;
      text-decoration: none;
      border-radius: 5px;
      margin: 15px 0;
      font-weight: 500;
    }
  </style>
</head>
<body>
  <div class="header">
    <h1 style="color: white; font-weight: 600;">Special Offer Just For You!</h1>
  </div>
  <div class="content">
    <p>Dear {{firstName}},</p>
    <p>We're excited to offer you this exclusive deal:</p>
    <div class="offer">[[offer]]</div>
    <p>This special offer is valid until [[expiryDate]]. Don't miss out!</p>
    <p><a href="#" class="button" style="color: white;">Claim Your Offer</a></p>
    <p>If you have any questions, please don't hesitate to contact us.</p>
    <p>Best regards,<br>The {{businessName}} Team</p>
  </div>
  <div class="footer">
    <p>© {{year}} {{businessName}}. All rights reserved.</p>
    <p><a href="#">Unsubscribe</a> | <a href="#">View in browser</a></p>
  </div>
</body>
</html>
`
  },
  {
    id: 'newsletter',
    name: 'Monthly Newsletter',
    description: 'Monthly updates and news for your customers',
    subject: '{{businessName}} Newsletter - [[month]] Updates',
    thumbnail: '📰',
    htmlContent: `
<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Monthly Newsletter</title>
  <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap" rel="stylesheet">
  <style>
    body {
      font-family: 'Poppins', sans-serif;
      line-height: 1.6;
      color: #333;
      max-width: 600px;
      margin: 0 auto;
      padding: 20px;
    }
    .header {
      background-color: #4ECDC4;
      color: white;
      padding: 20px;
      text-align: center;
      border-radius: 5px 5px 0 0;
    }
    .content {
      padding: 20px;
      background-color: #f9f9f9;
      border: 1px solid #eee;
    }
    .article {
      margin-bottom: 20px;
      border-bottom: 1px solid #eee;
      padding-bottom: 20px;
    }
    .article-title {
      color: #1A535C;
      font-size: 18px;
      margin-bottom: 5px;
      font-weight: 600;
    }
    .footer {
      text-align: center;
      padding: 10px;
      font-size: 12px;
      color: #666;
    }
    .button {
      display: inline-block;
      padding: 8px 15px;
      background-color: #4ECDC4;
      color: white;
      text-decoration: none;
      border-radius: 5px;
      font-size: 14px;
      font-weight: 500;
    }
  </style>
</head>
<body>
  <div class="header">
    <h1 style="color: white; font-weight: 600;">{{businessName}} Newsletter</h1>
    <h2 style="color: white; font-weight: 500;">[[month]] {{year}}</h2>
  </div>
  <div class="content">
    <p>Dear {{firstName}},</p>
    <p>Here's what's new this month at {{businessName}}:</p>
    
    <div class="article">
      <h3 class="article-title">New Product Launch</h3>
      <p>We're excited to announce the launch of our newest product, which offers incredible features that will transform your experience.</p>
      <a href="#" class="button" style="color: white;">Learn More</a>
    </div>
    
    <div class="article">
      <h3 class="article-title">Upcoming Events</h3>
      <p>Join us for our upcoming webinar where we'll discuss industry trends and share valuable insights.</p>
      <a href="#" class="button" style="color: white;">Register Now</a>
    </div>
    
    <div class="article">
      <h3 class="article-title">Tips & Tricks</h3>
      <p>Discover how to make the most of our platform with these expert tips from our team.</p>
      <a href="#" class="button" style="color: white;">Read More</a>
    </div>
    
    <p>We hope you found this newsletter informative. Stay tuned for more updates next month!</p>
    <p>Best regards,<br>The {{businessName}} Team</p>
  </div>
  <div class="footer">
    <p>© {{year}} {{businessName}}. All rights reserved.</p>
    <p><a href="#">Unsubscribe</a> | <a href="#">View in browser</a></p>
  </div>
</body>
</html>
`
  },
  {
    id: 'stripe-inspired',
    name: 'Modern Invoice',
    description: 'A clean, modern invoice email inspired by Stripe',
    subject: 'Your {{businessName}} Invoice #[[invoiceNumber]]',
    thumbnail: '📊',
    htmlContent: `
<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Invoice</title>
  <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap" rel="stylesheet">
  <style>
    body {
      font-family: 'Poppins', sans-serif;
      line-height: 1.6;
      color: #32325d;
      max-width: 600px;
      margin: 0 auto;
      padding: 20px;
      background-color: #f6f9fc;
    }
    .wrapper {
      background-color: white;
      border-radius: 8px;
      box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
      overflow: hidden;
    }
    .header {
      padding: 25px;
      text-align: center;
      border-bottom: 1px solid #f4f4f4;
    }
    .logo {
      max-width: 150px;
      margin-bottom: 15px;
    }
    .content {
      padding: 25px;
    }
    .invoice-details {
      margin: 25px 0;
      border: 1px solid #f4f4f4;
      border-radius: 4px;
      overflow: hidden;
    }
    .invoice-summary {
      background-color: #f6f9fc;
      padding: 15px;
      text-align: right;
      border-bottom: 1px solid #f4f4f4;
    }
    .invoice-info {
      padding: 15px;
    }
    .invoice-line {
      display: flex;
      justify-content: space-between;
      padding: 10px 0;
      border-bottom: 1px solid #f4f4f4;
    }
    .invoice-line:last-child {
      border-bottom: none;
    }
    .invoice-total {
      font-weight: 600;
      color: #32325d;
      font-size: 18px;
      padding-top: 20px;
      text-align: right;
    }
    .button {
      display: inline-block;
      background-color: #635bff;
      color: white;
      padding: 12px 28px;
      text-decoration: none;
      border-radius: 25px;
      font-weight: 500;
      text-align: center;
      letter-spacing: 0.5px;
      transition: all 0.2s ease;
    }
    .button:hover {
      background-color: #5851e6;
    }
    .footer {
      background-color: #f6f9fc;
      padding: 20px;
      text-align: center;
      color: #8898aa;
      font-size: 12px;
      margin-top: 25px;
    }
    .footer a {
      color: #635bff;
      text-decoration: none;
    }
  </style>
</head>
<body>
  <div class="wrapper">
    <div class="header">
      <h1 style="font-weight: 600; color: #32325d; margin: 0;">Invoice from {{businessName}}</h1>
      <p style="color: #8898aa; margin-top: 5px;">Invoice #[[invoiceNumber]]</p>
    </div>
    
    <div class="content">
      <p>Hello {{firstName}},</p>
      <p>Your invoice for [[invoiceDate]] is ready. Please find the details below:</p>
      
      <div class="invoice-details">
        <div class="invoice-summary">
          <p style="margin: 0; font-size: 14px; color: #8898aa;">Amount due</p>
          <p style="margin: 5px 0 0; font-size: 24px; font-weight: 500; color: #32325d;">[[invoiceAmount]]</p>
        </div>
        
        <div class="invoice-info">
          <div class="invoice-line">
            <span>Invoice date</span>
            <span>[[invoiceDate]]</span>
          </div>
          <div class="invoice-line">
            <span>Due date</span>
            <span>[[dueDate]]</span>
          </div>
          <div class="invoice-line">
            <span>Invoice number</span>
            <span>#[[invoiceNumber]]</span>
          </div>
        </div>
      </div>
      
      <div class="invoice-line">
        <span>[[itemDescription]]</span>
        <span>[[itemAmount]]</span>
      </div>
      
      <div class="invoice-total">
        <span>Total: [[invoiceAmount]]</span>
      </div>
      
      <p style="margin-top: 30px; text-align: center;">
        <a href="#" class="button" style="color: white;">Pay Invoice</a>
      </p>
      
      <p style="margin-top: 30px;">If you have any questions, please feel free to contact our support team.</p>
      
      <p>Thank you for your business!<br>{{businessName}} Team</p>
    </div>
    
    <div class="footer">
      <p>© {{year}} {{businessName}}. All Rights Reserved.</p>
      <p><a href="#">Terms</a> • <a href="#">Privacy</a> • <a href="#">Unsubscribe</a></p>
    </div>
  </div>
</body>
</html>
`
  },
  {
    id: 'shopify-inspired',
    name: 'Product Announcement',
    description: 'Modern product launch email inspired by Shopify',
    subject: 'New Arrival: [[productName]] - Now Available!',
    thumbnail: '🛍️',
    htmlContent: `
<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>New Product Announcement</title>
  <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap" rel="stylesheet">
  <style>
    body {
      font-family: 'Poppins', sans-serif;
      line-height: 1.6;
      color: #212b36;
      max-width: 600px;
      margin: 0 auto;
      padding: 0;
      background-color: #f4f6f8;
    }
    .container {
      background-color: white;
      border-radius: 8px;
      overflow: hidden;
      box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
    }
    .header {
      background-color: #004c3f;
      padding: 30px;
      text-align: center;
    }
    .header-content {
      max-width: 500px;
      margin: 0 auto;
    }
    .title {
      font-size: 28px;
      color: white;
      margin-bottom: 15px;
      font-weight: 600;
    }
    .subtitle {
      font-size: 16px;
      color: rgba(255, 255, 255, 0.9);
      margin-top: 0;
      font-weight: 400;
    }
    .content {
      padding: 30px;
    }
    .product-img {
      width: 100%;
      border-radius: 6px;
      margin-bottom: 25px;
    }
    .product-title {
      font-size: 22px;
      font-weight: 600;
      margin-bottom: 10px;
      color: #212b36;
    }
    .product-description {
      color: #637381;
      margin-bottom: 25px;
    }
    .price {
      font-size: 18px;
      font-weight: 600;
      color: #212b36;
      margin-bottom: 25px;
    }
    .features {
      margin-bottom: 25px;
    }
    .feature {
      display: flex;
      margin-bottom: 15px;
    }
    .feature-icon {
      margin-right: 10px;
      font-size: 16px;
      color: #004c3f;
    }
    .cta-button {
      display: inline-block;
      background-color: #004c3f;
      color: white;
      padding: 14px 32px;
      font-size: 16px;
      font-weight: 500;
      text-decoration: none;
      border-radius: 4px;
      text-align: center;
      margin-top: 10px;
    }
    .testimonial {
      background-color: #f9fafb;
      padding: 20px;
      border-radius: 6px;
      margin: 25px 0;
      border-left: 3px solid #004c3f;
    }
    .footer {
      background-color: #f9fafb;
      padding: 25px;
      text-align: center;
      color: #637381;
      font-size: 12px;
      border-top: 1px solid #e4e9ed;
    }
    .social-links {
      margin: 15px 0;
    }
    .social-link {
      display: inline-block;
      margin: 0 8px;
      color: #004c3f;
      text-decoration: none;
      font-weight: 500;
    }
  </style>
</head>
<body>
  <div class="container">
    <div class="header">
      <div class="header-content">
        <h1 class="title">Introducing [[productName]]</h1>
        <p class="subtitle">Our newest addition is now available!</p>
      </div>
    </div>
    
    <div class="content">
      <p>Hello {{firstName}},</p>
      
      <p>We're excited to announce our newest product is now available.</p>
      
      <div style="text-align: center;">
        <img src="https://placehold.co/540x300" alt="[[productName]]" class="product-img">
      </div>
      
      <h2 class="product-title">[[productName]]</h2>
      <p class="product-description">[[productDescription]]</p>
      
      <p class="price">[[productPrice]]</p>
      
      <div class="features">
        <div class="feature">
          <span class="feature-icon">✓</span>
          <span>[[feature1]]</span>
        </div>
        <div class="feature">
          <span class="feature-icon">✓</span>
          <span>[[feature2]]</span>
        </div>
        <div class="feature">
          <span class="feature-icon">✓</span>
          <span>[[feature3]]</span>
        </div>
      </div>
      
      <div style="text-align: center;">
        <a href="#" class="cta-button" style="color: white;">Shop Now</a>
      </div>
      
      <div class="testimonial">
        <p style="margin: 0; font-style: italic;">"[[testimonialQuote]]"</p>
        <p style="margin: 10px 0 0; font-weight: 500;">– [[testimonialAuthor]]</p>
      </div>
      
      <p>We're sure you'll love this new addition to our collection.</p>
      
      <p>Best regards,<br>The {{businessName}} Team</p>
    </div>
    
    <div class="footer">
      <div class="social-links">
        <a href="#" class="social-link">Facebook</a>
        <a href="#" class="social-link">Instagram</a>
        <a href="#" class="social-link">Twitter</a>
      </div>
      <p>© {{year}} {{businessName}}. All rights reserved.</p>
      <p><a href="#" style="color: #004c3f;">Unsubscribe</a> | <a href="#" style="color: #004c3f;">View in browser</a></p>
    </div>
  </div>
</body>
</html>
`
  }
];

const EmailTemplates = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      {emailTemplates.map((template) => (
        <div key={template.id} className="border rounded-lg p-4 hover:border-primary cursor-pointer">
          <div className="text-4xl mb-2">{template.thumbnail}</div>
          <h3 className="font-medium">{template.name}</h3>
          <p className="text-sm text-muted-foreground">{template.description}</p>
        </div>
      ))}
    </div>
  );
};

export default EmailTemplates; 